import "./newTicketOpen.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../context/newRequest";
import {useNavigate} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import Select from 'react-select';

const NewTicketOpen = ({ inputs, title, region }) => {
  const [ticketOpen, setTicketOpen] = useState({});
  const [categoryId, setCategoryId] = useState(["DOWN"]);
  const [statusId, setStatusId] = useState(["OPEN"]);
  const [sending, setSending] = useState("");
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/allusers?region_id=${region}`);
  const regionId = region;


  const handleSelectCategoryID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };

  const handleSelectStatusID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setStatusId(value);
  };


  const handleChange = (e) => {
    setTicketOpen((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit")
      const newTicketOpen = {
        ...ticketOpen,
        category_id : categoryId[0],
        status_id : statusId[0],
        region_id : regionId
      };

     const res= await newRequest.post("/ticket", newTicketOpen, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      } );
      setSending("Mengirim Submit")

      const data = res.data.data
      if (res.status === 200) {
        setSending("Submit berhasil")
        navigate(`/ticket/${data.id}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err.response.data.data);
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              <div className="formInput">
                <label>Segment Customer </label>
                <textarea placeholder="segmet customer" onChange={handleChange} id="segment_customer"/>
                <label className="label">Status</label>
                <select id="status_id" onChange={handleSelectStatusID}>
                  <option value="OPEN">Open</option>
                  <option value="PENDING">Pending</option>
                </select>
                <label className="label">Category</label>
                <select id="category_id" onChange={handleSelectCategoryID}>
                  <option value="ONUBAD">ONU Bad</option>

                  <option value="FIBERCUT">Fiber Cut</option>

                  <option value="POWEROFF">Power OFF</option>
                  <option value="INTERMITTEN">INTERMITTEN</option>
                  <option value="LOOPING">LOOPING</option>
                  <option value="BENDING">BENDING</option>
                  <option value="ELECTRICAL">ELECTRICAL</option>

                </select>
                <label>Choose a user</label>
                <select
                    id="user_id"
                    onChange={handleChange}
                >
                  <option key="salah" value="">Pilih Data user</option>
                  {loading
                      ? "loading"
                      : data &&
                      data.map((data) => (
                          <option key={data.id} value={data.id}>{data.id.toUpperCase()}</option>
                      ))}

                </select>
              </div>
            </form>
            <button onClick={handleClick}>Send</button>
          </div>
        </div>
        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default NewTicketOpen;
